var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-button',{staticClass:"button-option",class:{ active: _vm.value },attrs:{"aria-controls":_vm.controls,"collapse":_vm.collapse,"aria-expanded":"false","data-toggle":"collapse"},on:{"click":_vm.toggle}},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }